import { render, staticRenderFns } from "./PendingReplacementsGridNew.vue?vue&type=template&id=1024e4f3&"
import script from "./PendingReplacementsGridNew.vue?vue&type=script&lang=js&"
export * from "./PendingReplacementsGridNew.vue?vue&type=script&lang=js&"
import style0 from "./PendingReplacementsGridNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports